import { isArray, set } from 'lodash';
import { roundOff } from '../../../Components/helper';
import { usePlanningBottomupState } from '../Context';
import useFPSalesHooks from './FPSalesHooks';
import useMdCalculationHooks from './MdHooks';
import useMonthlyPlanningHooks from './MonthlyPlanSellingHooks';
import useTerminalCalculationHooks from './useTerminalCalculationHooks';

export default function useTotalCalculationHooks() {
  const { planningBottomup } = usePlanningBottomupState();
  const mainlevel = planningBottomup?.selectedLevel?.level || 0;
  const { caluculateTotalPWS } = useMonthlyPlanningHooks();
  const { caluculateFPSSales } = useFPSalesHooks();
  const { calculateTerminal } = useTerminalCalculationHooks();
  const { calculateMd } = useMdCalculationHooks();

  const calCulateTotal = async (PlanningBottomData) => {
    if (isArray(PlanningBottomData)) {
      const calculatedArray = [];
      if (mainlevel >= 6) {
        await Promise.all(
          PlanningBottomData.map(async (data) => {
            let currenObj = data;
            const totalPWS = await caluculateTotalPWS(currenObj);
            set(currenObj, 'totalPWS', totalPWS);
            const { fpSalesUnits, fpSalesValue } = await caluculateFPSSales(currenObj);
            currenObj = { ...currenObj, fpSalesUnits, fpSalesValue };
            set(currenObj, 'fpSalesUnits', fpSalesUnits);
            set(currenObj, 'fpSalesValue', fpSalesValue);
            currenObj = await calculateMd(currenObj);
            currenObj = await calculateTerminal(currenObj, mainlevel);
            calculatedArray.push(currenObj);
          }),
        );
      } else {
        await Promise.all(
          PlanningBottomData.map(async (data) => {
            const currenObj = data;
            const totalPWS = await caluculateTotalPWS(currenObj);
            set(currenObj, 'totalPWS', totalPWS);
            calculatedArray.push(currenObj);
          }),
        );
      }
      return calculatedArray;
    }
  };

  const getRatioValue = (level) => {
    if (level === 7) {
      return 'sizeRatio';
    }
    if (level === 8) {
      return 'lengthRatio';
    }
  };
  const getCalval = (total, sizeRatio) => {
    return roundOff(Number(total) * Number(sizeRatio), 2);
  };
  const calculatedChannelCostArray = (copyState, index, level) => {
    const { basicInfo, _id, channels } = copyState[index];
    const currentStateData = copyState[index];
    const { colour } = basicInfo;
    for (const channelKey in channels) {
      const currentCost = currentStateData[channelKey]?.cost;
      const costType = currentStateData[channelKey]?.costType;
      let total = 0;
      if (costType === 'manual') {
        if (currentCost?.totalCost > 0) {
          total = Number(currentCost?.totalCost);
        } else {
          const filtered = copyState?.filter((data) => data._id === _id && data[channelKey]?.cost?.colourway === colour?._id);
          filtered?.forEach((element) => {
            total += Number(element[channelKey]?.cost?.value);
          });
        }
        copyState = copyState.map((eleData) => {
          const ratioValue = getRatioValue(level);
          if (eleData._id === _id && eleData[channelKey]?.cost?.colourway === colour?._id && eleData[channelKey]) {
            // Ensure the cost object exists before setting its value
            if (!eleData[channelKey].cost) {
              eleData[channelKey].cost = {};
            }
            eleData[channelKey].cost.value = getCalval(total, eleData[ratioValue]?.value);
          }
          return eleData;
        });
      }
    }
    return copyState;
  };

  const calculatedChannelUnitArray = (copyState, index, level) => {
    const { basicInfo, _id, channels } = copyState[index];
    const currentStateData = copyState[index];
    const { colour } = basicInfo;
    for (const channelKey in channels) {
      const currentUnit = currentStateData[channelKey]?.unit;
      const unitType = currentStateData[channelKey]?.unitType;
      let total = 0;
      if (unitType === 'manual') {
        if (currentUnit?.totalUnit > 0) {
          total = Number(currentUnit?.totalUnit);
        } else {
          const filtered = copyState?.filter((data) => data._id === _id && data[channelKey]?.unit?.colourway === colour?._id);
          filtered?.forEach((element) => {
            total += Number(element[channelKey]?.unit?.value);
          });
        }
        copyState = copyState.map((eleData) => {
          const ratioValue = getRatioValue(level);
          if (eleData._id === _id && eleData[channelKey]?.unit?.colourway === colour?._id && eleData[channelKey]) {
            // Ensure the unit object exists before setting its value
            if (!eleData[channelKey].unit) {
              eleData[channelKey].unit = {};
            }
            eleData[channelKey].unit.value = getCalval(total, eleData[ratioValue]?.value);
          }
          return eleData;
        });
      }
    }
    return copyState;
  };

  return { calCulateTotal, calculatedChannelCostArray, calculatedChannelUnitArray };
}
